export default __webpack_public_path__ + "static/media/Present.5818285b.svg";